/**
 * IAM permission codes used by the web. Mirrors api/src/modules/iam/permissions.ts.
 * Arrays mean "any of".
 */
export const P = {
  user: { read: 'iam.user.read', create: 'iam.user.create', update: 'iam.user.update' },
  /** granting / revoking roles and security actions on accounts (server checks each precisely) */
  userAdmin: ['iam.role.grant', 'iam.user.manage_security', 'iam.user.update'],
  role: { read: 'iam.role.read', create: 'iam.role.configure', update: 'iam.role.configure', export: 'iam.role.export' },
  delegation: ['iam.delegation.manage', 'iam.delegation.create_own'],
  accessReview: ['iam.access_review.manage', 'iam.access_review.perform'],
  auditLog: 'iam.audit_log.read',
  sodReport: 'iam.sod.report',
} as const;
